import { getLayer } from '../openlayers-utils/layer-utilities';
import { v4 } from "uuid";
import { createSelector } from 'redux-bundler';
import xhr from 'xhr';
/**
 * Private methods basically
 */

 function getESRIFeatureServiceInfo(options){
   
  return new Promise(function(resolve, reject) {
    let serviceUrl = options.url;
    const layer = options.layerList;
    const trailingSlashMatch = /\/$/;
  
    if(!trailingSlashMatch.test(serviceUrl)) serviceUrl += '/';
    const layerInfoURL = `${serviceUrl}${layer}?f=json`

    xhr.get(layerInfoURL, (err, response, body) => {
      if(err) {
        reject(console.log(err));
      } else{
        const data = JSON.parse(body);
        resolve(data)
      }
    })    
  })
}

const createNode = (options) => {
  if(!options.type) options.type = options.serviceType || 'Folder';

  if(!options.uid) options.uid = v4();
  const node = {
    id: options.id,
    teamDatasetId: options.teamDatasetId,
    uid: options.uid,
    parent: null,
    children: [],
    root: options.root || false,
    leaf: options.type !== 'Folder',
    collapsed: options.collapsed || false,
    visible: options.visible || false,
    notWithinZoom: false,
    sortOrder: options.layerOrder || 0,
    displayName: options.displayName,
    type: options.type,
    geometryType: options.geometryType,
    extent:options.extent,
    layerList: options.layerList,
    legendURL:options.legendURL,
    libraryName: options.libraryName,
    dsName: options.teamDatasetId ? options.teamDatasetId : options.dsName || null,
    mapLayer: options.type !== 'Folder' ? options.mapLayer || getLayer(options) : null,
    labelsOn: options.labelsOn ? options.labelsOn : !!options.labelDefault,
    labelDefault: !!options.labelDefault,
    labelEnabled: !!options.labelEnabled,
    table: options.table || null,
    url: options.url,
    dlUrl: options.dlUrl,
    info: options.info
  }
  return node;
}

const isParentOf = (queryNode, destNode) => {
  let ancestors = [];
  function familyTree(node){
    if(node.parent){
      ancestors.push(node.parent);
      familyTree(node.parent);
    }
  }
  familyTree(destNode);
  return ancestors.indexOf(queryNode) !== -1;
}

const removeFromParent = (node) => {
  const parent = node.parent;
  if(parent){
    const idx = parent.children.indexOf(node);
    parent.children.splice(idx, 1);
  }else{
    
  }
}

const insertNodeAt = (node, parent, idx) => {
  node.parent = parent;
  parent.children.splice(idx, 0, node);
}

/**
 *  Start store bundle config
 */

export default {
  defaultParentUid: null,
  name: 'layers',

  getReducer(){
    const initialState = {
      appTime: null,
      layers: {},
      idMap: {},
      resetNeeded: false,
      isLoading: false,
      isLoadingText: '',
      loadingPanel: null
    }

    return (state = initialState, { type, payload }) => {

      if(type === 'LAYERS_LIST_UPDATED'){
        return Object.assign({}, state, {
          appTime: new Date(),
          layers: payload,
          resetNeeded: false
        })
      }

      if(type === 'LAYERS_IDMAP_UPDATED'){
        return Object.assign({}, state, {
          appTime: new Date(),
          idMap: payload
        })
      }

      if(type === 'LAYERS_ORDER_UPDATED'){
        return Object.assign({}, state, {
          resetNeeded: false
        })
      }

      switch(type){
        case 'LAYERS_LOADING_START':
        case 'LAYERS_LOADING_STOP':
          return Object.assign({}, state, payload);
        default:
          return state;
      }
    }
  },

  doAddLayer: (options) => ({ dispatch, store }) => {
    
   

    if(options.serviceType==='EsriFeatureService') {
      getESRIFeatureServiceInfo(options).then((info)=>{
        const layers = store.selectLayers();
        const idMap = store.selectIdMap();
        const map = store.selectMap();
        const newOptions = Object.assign({}, options);
        newOptions.layerInfo = info;
        const node = createNode(newOptions);
        if(newOptions.id){
          const newIdMap = Object.assign({}, idMap, {
            [newOptions.id]: node.uid
          })
          dispatch({type:'LAYERS_IDMAP_UPDATED', payload: newIdMap});
        }
        
        if(newOptions.parentUid){
          const parent = layers[newOptions.parentUid];
          node.parent = parent;
          parent.children.unshift(node);         
        }
        if(node.mapLayer){
          map.addLayer(node.mapLayer);
        }
    
        const newLayers = Object.assign({}, layers, {
          [node.uid]: node
        })
    
        dispatch({type:'LAYERS_LIST_UPDATED', payload: newLayers});
      })
    }else{
      const layers = store.selectLayers();
      const idMap = store.selectIdMap();
      const map = store.selectMap();
      const node = createNode(options);
      if(options.id){
        const newIdMap = Object.assign({}, idMap, {
          [options.id]: node.uid
        })
        dispatch({type:'LAYERS_IDMAP_UPDATED', payload: newIdMap});
      }
      
      if(options.parentUid){
        const parent = layers[options.parentUid];
        node.parent = parent;
        parent.children.unshift(node);
      }
      if(node.mapLayer){
        map.addLayer(node.mapLayer);
      }
  
      const newLayers = Object.assign({}, layers, {
        [node.uid]: node
      })
  
      dispatch({type:'LAYERS_LIST_UPDATED', payload: newLayers});
    }
    
  }, 

  doTreeInsertAfter: (nodeId, destId) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    const destNode = layers[destId];
    if(!isParentOf(node, destNode)){
      removeFromParent(node);
      const parent = destNode.parent;
      const idx = parent.children.indexOf(destNode) + 1;
      insertNodeAt(node, parent, idx);
    }
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doTreeInsertBefore: (nodeId, destId) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    const destNode = layers[destId];
    if(!isParentOf(node, destNode)){
      removeFromParent(node);
      const parent = destNode.parent;
      const idx = parent.children.indexOf(destNode);
      insertNodeAt(node, parent, idx);
    }
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doTreeInsertChild: (nodeId, destId) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    const destNode = layers[destId];
    if(!isParentOf(node, destNode)){
      removeFromParent(node);
      const parent = destNode;
      insertNodeAt(node, parent, parent.children.length);
    }
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doTreeMerge: (nodeId, destId) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    const destNode = layers[destId];

    if(!isParentOf(node, destNode)){
      const parent = destNode.parent;
      const idx = parent.children.indexOf(destNode);

      removeFromParent(node);
      
      const newFolder = createNode({
        root: false,
        leaf: false,
        teamDatasetId: null,
        collapsed: false,
        visible: false,
        sortOrder: 0,
        displayName: 'New Folder',
        type: 'Folder'
      })

      node.parent = newFolder;
      destNode.parent = newFolder;

      newFolder.children.push(destNode);
      newFolder.children.push(node);
      newFolder.parent = parent;
      parent.children.splice(idx, 1, newFolder);
    }
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doTreeRemove: (nodeId) => ({dispatch, store}) => {
    const map = store.selectMap();
    const layers = store.selectLayers();
    const node = layers[nodeId];
    if(node) {
      function rm(n){
        if(n.children && n.children.length){
          n.children.forEach((c) => {
            rm(c);
          })
        }
        if(n.mapLayer){
          map.removeLayer(n.mapLayer);
        }
        delete layers[n.uid];
      }
      rm(node);
      removeFromParent(node);
      dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
      dispatch({type:'LAYER_REMOVED', payload: { uid: nodeId }});
    }
    
  },
  doTreeClear: (nodeId) => ({dispatch, store}) => {
    const map = store.selectMap();
    const layers = store.selectLayers();
    const node = layers[nodeId];
    if(node) {
      function rm(n){
        if(n.children && n.children.length){
          n.children.forEach((c) => {
            rm(c);
          })
        }
        if(n.mapLayer){
          map.removeLayer(n.mapLayer);
        }
        layers[n.uid] =[];
      }
      rm(node);
    }    
  },


  doTreeUpdate: (nodeId, updateObj) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    Object.keys(updateObj).forEach((key) => {
      if(key !== 'uid'){
        node[key] = updateObj[key];
      }
    })
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doTreeSetCollapsedAll: (nodeId, collapsed) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    function setCollapsedDownstream(n) {
      n.collapsed = collapsed;
      if (n.children.length > 0) {
        n.children.forEach(setCollapsedDownstream)
      }
    }
    setCollapsedDownstream(node);
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },
  
  doTreeSetVisibleAll: (nodeId, visible) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    function setVisibleDownstream(n){
      if(n.mapLayer){
        n.mapLayer.setVisible(visible);
        n.visible = visible;
      }
      if(n.children.length > 0){
        n.children.forEach(setVisibleDownstream);
      }
    }
    setVisibleDownstream(node);
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doLayerSetVisible: (nodeId, visible) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    if(node.mapLayer){
      node.visible = visible;
      node.mapLayer.setVisible(visible);
    }
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doLayerSetLabels: (nodeId, labelsOn) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];

    function formatLabeledUrl(url){
      const delim = url.indexOf('?') === -1 ? '?' : '&';
      return `${url}${delim}label=true`;
    }

    if(node.mapLayer){
      node.labelsOn = labelsOn;
      const src = node.mapLayer.getSource();
      const urls = src.getUrls();
      const newUrls = urls.map((url) => {
        return !labelsOn ? node.url : formatLabeledUrl(node.url);
      })
      src.setUrls(newUrls);
    }

    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doLayerSetLayerOrder: (nodeId, sortOrder) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    if(node.mapLayer){
      node.sortOrder = sortOrder;
      node.mapLayer.setZIndex(sortOrder);
    }
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doLayerSetOpactiy: (nodeId, opacity) => ({dispatch, store}) => {
    const layers = store.selectLayers();
    const node = layers[nodeId];
    if(node.mapLayer) node.mapLayer.setOpacity(opacity);
    dispatch({type:'LAYERS_LIST_UPDATED', payload: Object.assign({},layers)});
  },

  doUpdateLayerOrder: () => ({dispatch, store}) => {
    const root = store.selectTreeRootNode();
    let o = 999;
    function setOrder(node){
      let sortOrder = o--;
      if(node.mapLayer){
        node.sortOrder = sortOrder;
        node.mapLayer.setZIndex(sortOrder);
      }
      if(node.children){
        node.children.forEach(setOrder);
      }
    }
    setOrder(root);
    dispatch({type:'LAYERS_ORDER_UPDATED'});
  },

  selectLayers: (state) => {
    return state.layers.layers;
  },

  selectIdMap: (state) => {
    return state.layers.idMap;
  },

  selectUidMap: createSelector(
    'selectLayers',
    (layers) => {
      const uidMap = {};
      Object.keys(layers).forEach((key) => {
        if(layers[key]){
          uidMap[key] = layers[key].displayName;
        }
      })
      return uidMap;
    }
  ),

  selectCmLayers: createSelector(
    'selectLayers',
    (layers) => {
      const cmLayers = [];
      Object.keys(layers).forEach((key) => {
        if(layers[key] && layers[key].teamDatasetId) cmLayers.push(layers[key].teamDatasetId);
      })
      return cmLayers;
    }
  ),

  selectVisibleLayers: createSelector(
    'selectLayers',
    (layers) => {
      const visibleLayers = [];
      Object.keys(layers).forEach((key) => {
        if(layers[key] && layers[key].visible) visibleLayers.push(layers[key]);
      })
      return visibleLayers;
    }
  ),

  selectVisibleCmLayers: createSelector(
    'selectLayers',
    (layers) => {
      const visibleCmLayers = [];
      Object.keys(layers).forEach((key) => {
        if(layers[key] && layers[key].teamDatasetId && layers[key].visible) visibleCmLayers.push(layers[key].teamDatasetId);
      })
      return visibleCmLayers;
    }
  ),

  selectCmLayerNames: createSelector(
    'selectLayers', 
    (layers) => {
      const lyrNames = [];
      Object.keys(layers).forEach((key) => {
        if(layers[key] && layers[key].teamDatasetId) lyrNames.push({ teamDatasetId: layers[key].teamDatasetId, displayName: layers[key].displayName});
      })
      return lyrNames;
    }
  ),
  selectLoadingPanel: (state) => {
    return state.layers.loadingPanel;
  },
  selectIsLoading: (state) => {
    return state.layers.isLoading;
  },

  selectIsLoadingText: (state) => {
    return state.layers.isLoadingText;
  },
  selectLayerNotWithinZoom: (state) => {
    return state.layers.notWithinZoom;
  },

  reactResetSortOrder: (state) => {
    if(state.layers.resetNeeded) return { actionCreator: 'doUpdateLayerOrder' };
  }

}